import React from 'react';
import { FaFileInvoice, FaPalette, FaFileContract } from 'react-icons/fa';
// FaChartLine unused while Reporting nav item is commented out

export interface SidebarItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  path: string;
  badge?: string | number;
  children?: SidebarItem[];
}

export const getDefaultSidebarItems = (): SidebarItem[] => {
  const isDebug =
    typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { VITE_SHOW_DESIGN_PAGE?: string } }).env?.VITE_SHOW_DESIGN_PAGE === 'true';

  const baseItems: SidebarItem[] = [
    {
      key: 'quotes',
      label: 'Quotes',
      icon: React.createElement(FaFileInvoice, { className: 'text-lg' }),
      path: '/quotes',
    },
    {
      key: 'policy-admin',
      label: 'Policy Admin',
      icon: React.createElement(FaFileContract, { className: 'text-lg' }),
      path: '/policy-admin',
    },
    // {
    //   key: 'reporting',
    //   label: 'Reporting',
    //   icon: React.createElement(FaChartLine, { className: 'text-lg' }),
    //   path: '/reporting',
    // },
  ];

  if (isDebug) {
    baseItems.push({
      key: 'design-system',
      label: 'Design System',
      icon: React.createElement(FaPalette, { className: 'text-lg' }),
      path: '/design',
    });
  }

  return baseItems;
};

